import { makeStyles } from '@material-ui/core/styles';

import { DeliveryCity } from '../../types/delivery-city.type';
import { UpdateDeliveryCityRequestDTO } from '../../types/dtos/update-delivery-city.dto';
import { useDeliveryCityEditForm } from '../../hooks/use-delivery-city-edit-form.hook';
import { DeliveryCitySlotsEditor } from '../Editors/DeliveryCitySlotsEditor.component';
import { DeliveryCityCard } from './DeliveryCityCard.component';
import { DeliveryCityDetailsHeader } from './DeliveryCityDetailsHeader.component';
import { DeliveryCityIdentityCard } from './DeliveryCityIdentityCard.component';

type Props = {
  deliveryCity: DeliveryCity;
  isUpdating: boolean;
  updateDeliveryCity: (data: UpdateDeliveryCityRequestDTO) => Promise<DeliveryCity | null>;
  onArchiveActionClick: () => void;
};

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    gap: '1rem',

    '& h4': {
      margin: '0 0 0.5rem 0',
      opacity: 0.7,
    },

    '& .MuiButton-root': {
      textTransform: 'none',
    },

    '& .MuiOutlinedInput-root.Mui-focused:not(.Mui-error) .MuiOutlinedInput-notchedOutline': {
      borderColor: theme.palette.admin.primary.main,
    },
    '& .MuiInputLabel-outlined.Mui-focused:not(.Mui-error)': {
      color: theme.palette.admin.primary.main,
    },
  },
  body: {
    display: 'flex',
    gap: '2rem',

    '& > section': {
      flex: 1,
    },
  },
}));

export function DeliveryCityInformationsTab({
  deliveryCity,
  isUpdating,
  updateDeliveryCity,
  onArchiveActionClick,
}: Props) {
  const classes = useStyles();
  const {
    updatedDeliveryCity,
    isEditing,
    isNameInvalid,
    isZipCodeInvalid,
    hasInvalidEditedField,
    handleNameChange,
    handleZipCodeChange,
    handleZoneChange,
    handleIsActiveChange,
    handleSlotsChange,
    handleSave,
    resetForm,
  } = useDeliveryCityEditForm(deliveryCity, updateDeliveryCity);

  const isArchived = deliveryCity.archivedAt !== null;

  return (
    <section className={classes.root}>
      <DeliveryCityDetailsHeader
        deliveryCity={deliveryCity}
        isEditing={isEditing}
        isUpdating={isUpdating}
        canSave={isEditing && !isUpdating && !hasInvalidEditedField}
        onCancel={resetForm}
        onSave={handleSave}
        onArchiveActionClick={onArchiveActionClick}
      />
      <div className={classes.body}>
        <DeliveryCityIdentityCard
          updatedDeliveryCity={updatedDeliveryCity}
          isArchived={isArchived}
          isNameInvalid={isNameInvalid}
          isZipCodeInvalid={isZipCodeInvalid}
          onNameChange={handleNameChange}
          onZipCodeChange={handleZipCodeChange}
          onZoneChange={handleZoneChange}
          onIsActiveChange={handleIsActiveChange}
        />
        <DeliveryCityCard title="Créneaux">
          <DeliveryCitySlotsEditor slots={updatedDeliveryCity.slots} onChange={handleSlotsChange} />
        </DeliveryCityCard>
      </div>
    </section>
  );
}
